// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Users Area
export class AreaStorage {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(dataCore) {
        this.dataCore = dataCore;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Read
    /** Read data from key-value storage
     * @param designSystemId - Design system ID to read the data from
     * @param key - Unique data key to read
     */
    async readKeyValueStorageData(designSystemId, key) {
        var _a, _b;
        const data = await this.dataCore.readKeyValueStorageData(designSystemId, key);
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (data && data[key]) {
            try {
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument
                return (_a = JSON.parse(data[key])) !== null && _a !== void 0 ? _a : null;
            }
            catch (error) {
                // TODO:fix-sdk-eslint
                // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return (_b = data[key]) !== null && _b !== void 0 ? _b : null;
            }
        }
        return null;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Create/Update
    /** Set data to key-value storage. Limit of 20mb per a design system.
     * @param designSystemId - Design system ID to store data for
     * @param key - Unique data key under which the data will be stored
     * @param value - String or object to be stored. Anything else must be converted to JSON string first
     * @returns Nothing
     */
    async setKeyValueStorageData(designSystemId, key, value) {
        const stringValue = typeof value === "string" ? value : JSON.stringify(value, null, 0);
        await this.dataCore.setKeyValueStorageData(designSystemId, key, stringValue);
    }
    /** Unsets the data from key-value storage based on the key name
     * @param designSystemId - Design system ID to remove the data from
     * @param key - Unique data key to delete
     */
    async unsetKeyValueStorageData(designSystemId, key) {
        // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
        await this.dataCore.setKeyValueStorageData(designSystemId, key, null);
    }
}
